export default __webpack_public_path__ + "static/media/map-pin-selected.c0c25065.svg";